import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { I18nProvider } from "@lingui/react";
import { i18n, loadMessages } from "./i18n/i18n";
import { AuthProvider } from "./context/AuthContext";
import Layout from "./components/Layout/Layout";
import Home from "./pages/Home/Home";
import RegisterPage from "./pages/Auth/RegisterPage";
import LoginPage from "./pages/Auth/LoginPage";
import TicketPage from "./pages/Tickets/TicketPage";
import Dashboard from "./pages/ManagerDashboard/Dashboard";
import CheckTicket from "./pages/Tickets/CheckTicket";
import UserDashboard from "./pages/UserDashboard/UserDashboard";
import Reservations from "./pages/Reservations/Reservations";
import ReservationPage from "./pages/Reservations/ReservationPage";
import ReservationCheckPage from "./pages/Reservations/ReservationCheckPage";
import TicketFormOffline from "./components/Tickets/TicketFormOffline";
import OAuthCallback from "./components/Auth/OAuthCallback";
import InvoiceFixPage from "./pages/Invoice/InvoiceFixPage";
import "./App.css";
const App = () => {
  const [locale, setLocale] = useState(() => {
    return localStorage.getItem("lang") || "en";
  });

  const handleLanguageChange = (newLocale) => {
  console.log("--- START ZMIANY JĘZYKA ---", newLocale);
  loadMessages(newLocale); // Najpierw aktywacja Lingui
  setLocale(newLocale);    // Potem zmiana stanu Reacta
};

  useEffect(() => {
    // Wywołujemy funkcję z i18n.js
    loadMessages(locale);
    // Zapisujemy wybór
    localStorage.setItem("lang", locale);
    
    console.log("Stan locale w App zmieniony na:", locale);
  }, [locale]);

 
  return (
    <AuthProvider>
      <I18nProvider i18n={i18n} key={locale}>
        <main className="content" key={locale}>
        <Router>
         <Layout setLocale={handleLanguageChange}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/buy-tickets" element={<TicketPage />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/account" element={<UserDashboard />} />
              <Route path="/check-ticket" element={<CheckTicket />} />
              <Route path="/book-room" element={<Reservations />} />
              <Route path="/reservations" element={<ReservationPage />} />
              <Route path="/reservation-check" element={<ReservationCheckPage />} />
              <Route path="/sell-tickets" element={<TicketFormOffline />} />
              <Route path="/oauth/callback" element={<OAuthCallback />} />
              <Route path="/invoice/:invoiceRequestId" element={<InvoiceFixPage />} />
            </Routes>
            
          </Layout>
        </Router>
        </main>
      </I18nProvider>
    </AuthProvider>
  );
};

export default App;
